export const indicators = (state) => state.indicators;
export const globalIndicators = (state) => state.indicators.global;
export const personalIndicators = (state) => state.indicators.personal;
